export const APP_NAME = 'SocialMediaApp';
